<template>
  <div class="emoji">
    <ul class="emoji-wrapper clearfix">
      <li class="emoji-item" v-for="(name, index) in renderEmojiName" :key="index" :title="renderVal(name).value[0]" >
        <img :src="renderPic(name)" alt="" @click="selectEmoji( renderVal(name) )">
      </li>
    </ul>
  </div>
</template>

<script>
import emojiData from '@/libs/emoji/emoji-data'
export default {
  name: 'emoji',
  data () {
    return {
      emoji: emojiData
    }
  },
  computed: {
    renderEmojiName () {
      let nameArr = []
      for (let key in emojiData) {
        nameArr.push(key)
      }
      return nameArr
    }

  },
  methods: {
    /**
       * Author: brand
       * Creation Time: 2019-03-30 13:53
       * Description: 渲染表情图片
       */
    renderPic (name) {
      return require(`@/libs/emoji/images/${name}.gif`)
    },
    /**
       * Author: brand
       * Creation Time: 2019-03-30 13:53
       * Description: 渲染表情中文描述
       */
    renderVal (name) {
      for (let key in emojiData) {
        if (key === name) {
          return {
            name: name,
            value: emojiData[key]
          }
        }
      }
    },
    /**
       * Author: brand
       * Creation Time: 2019-03-30 13:52
       * Description: 选择表情
       */
    selectEmoji (data) {
      this.$emit('selectedEmoji', data)
    }
  },
  mounted () {

  }
}
</script>

<style lang="scss">
  .emoji{
    position: absolute;
    top: -188px;
    left: 0px;
    width: 380px;
    height: 186px;
    bottom: 0px;
    background: #fff;
    z-index: 10;
    border: 1px solid #e5e5e5;
    overflow-y: auto;
    overflow-x: hidden;
    .clearfix{
      zoom: 1;
      &:after{
        content: '.';
        display: block;
        height: 0;
        visibility: hidden;
        clear: both;
      }
    }
    .emoji-wrapper{
      display: inline-block;
      padding: 20px 0 0 20px;
      box-sizing: border-box;
      margin: 0 -20px 0 0;
      overflow: hidden;

      li{
        list-style: none;
        float: left;
        font-size: 0;
        cursor: pointer;
        margin: 0 20px 20px 0;
        img{
          display: inline-block;
          width: 24px;
          height: 24px;
          border: none;
        }
      }
    }
  }

</style>
